// Mirrors server/src/config/institutions.js's exact-domain matching
// (subdomains deliberately do not match) so the profile pages can show the
// institution logo before the server round trip confirms it. The server
// derivation is authoritative; disagreement here only delays the logo
// rendering correctly, never grants anything.
const DOMAIN_TO_INSTITUTION = Object.freeze({
    'msudenver.edu': 'msudenver',
    'ucdenver.edu': 'ucdenver',
    'ccd.edu': 'ccd',
    'ahec.edu': 'ahec',
});

export function institutionFromEmail(email) {
    if (typeof email !== 'string') {
        return null;
    }
    const at = email.lastIndexOf('@');
    if (at < 1 || at === email.length - 1) {
        return null;
    }
    const domain = email.slice(at + 1).toLowerCase();
    return DOMAIN_TO_INSTITUTION[domain] || null;
}
